exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".masechta-page .sponsors .card-body .btn-outline-secondary {\n  border-color: #aa4121;\n  width: 400px;\n  border-radius: 200px;\n}\n@media (max-width: 576px) {\n.masechta-page .sponsors .card-body .btn-outline-secondary {\n    width: 280px;\n}\n}\n.masechta-page .sponsors .card-body .btn-outline-secondary:hover {\n  background: #ccc;\n  border-color: #ccc;\n  color: #aa4121;\n}\n.masechta-page .sponsors .title {\n  background: #ce4217;\n}\n.masechta-page .sponsors .title .dropdown-toggle {\n  height: 50px;\n  border-radius: 100px;\n  padding: 0 20px;\n  background: #fff;\n  font-weight: bold;\n  font-size: 1rem;\n}\n.masechta-page .sponsors .title .dropdown-toggle .selected-tag {\n  color: #aa4121;\n}", ""]);

// exports
exports.locals = {
	"primary": "#aa4121",
	"secondary": "#ccc",
	"gray": "#636363"
};